<template>
  <div class="hot__goods" v-if="goodsList.length">
    <div class="hot__goods__header">
      <span class="hot__goods__header__title">热销商品</span>
      <span class="hot__goods__header__more pointer" @click="$router.push(`/store/${shopId}/goods`)">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div class="hot__goods__list">
      <GoodsInfo
        mini
        class="hot__goods__list__card pointer"
        v-for="goods in goodsList"
        :key="goods.itemCode"
        :goods="goods"
        :itemStyle="itemStyle"
        :imgStyle="imgStyle"
        :maskStyle="maskStyle"
        :detailsStyle="detailsStyle"
        itemType="hotSale"
        @click-goods="linkTo(goods.itemCode)"
      />
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import GoodsInfo from '@/components/GoodsInfo';
export default {
  props: ['shopId'],
  components: {
    GoodsInfo
  },
  computed: {
    itemCode() {
      return this.$route.params.id;
    }
  },
  watch: {
    '$route.params.id': function() {
      this.getRecommendGoods();
    }
  },
  data() {
    return {
      goodsList: [],
      searchRecommendGoodsParams: {
        pageNo: 1,
        pageSize: 4,
        orderType: 2,
        shopId: this.shopId,
        aggregateFlag: false
      },
      itemStyle: {
        width: '219px'
      },
      imgStyle: {
        width: '195px',
        height: '195px'
      },
      maskStyle: {
        padding: 0
      },
      detailsStyle: {
        padding: '8px 0 0 0'
      }
    };
  },
  methods: {
    // 获取热销商品列表
    async getRecommendGoods() {
      const {
        data: { itemBasicInfos }
      } = await api.goods.getGoodsList(this.searchRecommendGoodsParams);
      this.goodsList = itemBasicInfos.filter(item => item.itemCode !== this.itemCode).slice(0, 3);
    },
    linkTo(id) {
      this.$router.push({ path: `/goodsDetails/${id}` });
    }
  },
  created() {
    this.getRecommendGoods();
  }
};
</script>

<style lang="scss" scoped>
.hot__goods {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 24px;
    margin-bottom: 16px;
    &__title {
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      line-height: 1;
    }
    &__more {
      font-size: 16px;
      font-weight: 400;
      color: #bfbfbf;
      line-height: 1;
    }
  }
  &__list {
    padding-bottom: 24px;
    font-size: 0;
    &__card {
      width: 219px;
      padding: 12px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      & + .hot__goods__list__card {
        margin-top: 16px;
      }
    }
    .img {
      width: 195px;
      height: 195px;
    }
    .price {
      margin-top: 20px;
      margin-bottom: 4px;
      font-size: 18px;
      font-weight: 600;
      color: #fd5047;
      line-height: 1;
    }
    .desc {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 1.5;
    }
    .tags {
      display: flex;
      &__item {
        display: inline-block;
        font-size: 12px;
        height: 16px;
        padding: 2px 4px;
        color: #ffffff;
        line-height: 1;
        background: #ff8300;
        border-radius: 2px;
      }
    }
    .store {
      margin: 4px 0;
      font-size: 12px;
      font-weight: 400;
      color: #bcbcbc;
    }
    .stock {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
    }
  }
}
</style>
